import { cloneDeep } from 'lodash';

const convertArrToObj = (arr: any[], keyField: string | number) => Object.assign({}, ...arr.map((item) => ({ [item[keyField]]: cloneDeep(item) })));

export default convertArrToObj;
